<template>
  <v-combobox
    :items="items"
    append-icon="mdi-menu-down-outline"
    outlined
    flat
    dense
    hide-selected
    clearable
    autocomplete="false"
    v-bind="{ ...$attrs, ...$props, ...$listeners }"
    @input="$emit('input', $event)"
    @change="onChange"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <template #no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('form.hint.noResultsMatching') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import { find } from 'lodash-es'

export default {
  name: 'BaseCombobox',
  props: {
    items: {
      type: Array,
      required: true,
    },
    onlyListItems: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Array, Object],
      default: undefined,
    },
  },
  methods: {
    onChange(value) {
      this.$nextTick(() => {
        if (!this.onlyListItems) {
          return
        }

        const foundItem = find(this.items, value)
        const isInItems = !!foundItem

        if (isInItems) {
          this.$emit('change', value)
        } else {
          this.$emit('change', '')
        }
      })
    },
  },
}
</script>
